<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="top-title-wrap">
                    <div class="main-title">
                        <span>{{ $t('Transaction Management') }}</span>
                      <dspButtonGroup class="ml-1">
                        <dspButton class="active">{{
                            $t('Transactions')
                          }}</dspButton>
                        <router-link class="button" :to="{ name: 'admin.net-terms' }">{{ $t('Net Terms') }}
                        </router-link>
                      </dspButtonGroup>
                    </div>
                </div>
                <box boxClass="alt">
                    <tableTopActions class="reports-top-actions alt extended-top-actions-smallscreen">
                        <!--                        <dspButton class="primary">+ User</dspButton>-->
                        <router-link class="button primary"
                                     :to="{ name: 'admin.transactions.edit', params: { id: 'create' } }">
                            {{ $t('+ Transaction') }}
                        </router-link>
                        <dspInput v-model="searchText" @changed="searchText=$event" :placeholder="$t('Search')"
                                  class="search-input"></dspInput>
                        <dropdown v-model="searchField" :showSearch="false" :options="searchFieldsList">
                            <template v-slot:header="header">
                                <span>{{ header.value.title }}</span>
                            </template>
                            <template v-slot:item="item">
                                <span>{{ item.option.title }}</span>
                            </template>
                        </dropdown>
                        <dropdown v-model="type" :showSearch="false" :options="typesList">
                            <template v-slot:header="header">
                                <span>{{ header.value.title }}</span>
                            </template>
                            <template v-slot:item="item">
                                <span>{{ item.option.title }}</span>
                            </template>
                        </dropdown>
                        <dropdown v-model="status" :showSearch="false" :options="statusList">
                            <template v-slot:header="header">
                                <span>{{ header.value.title }}</span>
                            </template>
                            <template v-slot:item="item">
                                <span>{{ item.option.title }}</span>
                            </template>
                        </dropdown>
                        <div class="input-wrap">
                            <DateSelect :dateStart="fromDate.format('YYYY-MM-DD')"
                                        :dateEnd="toDate.format('YYYY-MM-DD')"
                                        :errorsBag="errors"
                                        :autoApply="false"
                                        :value="rangeName"
                                        opens="left"
                                        class="datepicker-smallscreen-shift"
                                        @change="onPeriodChange($event)"
                            />
                        </div>

                        <div class="ml-auto export-button-right">
                            <dspButton @click="exportToFile" class="primary">{{ $t('Export') }}</dspButton>
                        </div>
                    </tableTopActions>
                    <b-table hover
                             ref="transactionsTable"
                             :fields="fields"
                             :items="transactionsProvider"
                             :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc"
                             :show-empty="true"
                             :empty-text="$t('No data to display')">


                        <template v-for="(title, field) in sortableFields">
                            <template :slot="'HEAD_' + field">
                                <sortableColumnHead :title="title" :key="field"/>
                            </template>
                        </template>

                        <template slot="id" slot-scope="data">
                            <router-link :to="{name: 'admin.transactions.edit', params: {id: data.item.id}}"
                                         v-if="data.item.status === 'completed'">
                                {{ data.item.id }}
                            </router-link>
                            <span v-if="data.item.status !== 'completed'">
                                      {{ data.item.id }}
                                  </span>
                        </template>

                        <template slot="notes" slot-scope="data">
                            <dspTextEditable
                                v-if="data.item.notes"
                                v-model="data.item.notes"
                                @change="updateTransaction(data.item, $event, 'notes')">

                            <span
                                v-b-tooltip
                                :title="data.item.notes"
                                v-if="data.item.notes.length > 10 "
                            >
                                 {{ sliceText(data.item.notes) }} ...
                            </span>
                                <span v-else>{{ data.item.notes }}</span>

                            </dspTextEditable>
                        </template>


                        <template slot="transactionAmount" slot-scope="data">
                            $ {{ data.item.transactionAmount | finance }}
                        </template>
                        <template slot="balanceAfter" slot-scope="data">
                            <span v-if="data.item.status==='completed'">$ {{ data.item.balanceAfter | finance }}</span>
                            <span v-else-if="data.item.status==='canceled'"></span>
                            <span v-else>$ {{
                                    Number.parseFloat(data.item.userBalance) + Number.parseFloat(data.item.transactionAmount) | finance
                                }}</span>
                        </template>
                        <template slot="actions" slot-scope="data">
                            <template v-if="data.item.type !== 'adCampaignsDailySpend'">
                                <a @click.prevent="edit(data.item)" class="decline"
                                   v-if="data.item.status === 'completed'">
                                    <svg width="12" height="11" viewBox="0 0 12 11" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">\
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M0.113048 10.443C0.0742237 10.5711 0.113676 10.7082 0.216159 10.8023C0.280309 10.861 0.362817 10.8972 0.449792 10.9074C0.362851 10.8971 0.280379 10.861 0.216252 10.8023C0.113769 10.7082 0.0743165 10.5711 0.11314 10.443L1.05717 7.31913C1.07572 7.25775 1.11124 7.20186 1.16044 7.15676L8.33925 0.576787C8.72251 0.225493 9.23482 0.0645924 9.73629 0.0940838C9.23479 0.0645671 8.72244 0.225466 8.33915 0.576781L1.16035 7.15676C1.11115 7.20185 1.07563 7.25775 1.05708 7.31912L0.113048 10.443ZM0.146557 10.866C0.0190932 10.749 -0.0300577 10.5783 0.0182772 10.4189L0.96229 7.29505C0.985368 7.21869 1.02958 7.14911 1.0908 7.093L8.2696 0.513023C9.01518 -0.170357 10.2239 -0.170357 10.9695 0.513023L11.4418 0.945881C12.1861 1.62968 12.1861 2.73672 11.4417 3.42052L4.26303 10.0006C4.20181 10.0567 4.12591 10.0973 4.0426 10.1184L0.6344 10.9839C0.460506 11.028 0.274216 10.9828 0.146557 10.866ZM10.3764 3.22634L10.3765 3.22638L10.8032 2.83523C11.1954 2.47491 11.1954 1.89157 10.8032 1.53111L10.3309 1.09832C10.1713 0.952042 9.97142 0.865202 9.76398 0.837788C9.97138 0.865216 10.1712 0.952058 10.3308 1.09832L10.8031 1.5311C11.1953 1.89157 11.1953 2.47491 10.8031 2.83523L10.3764 3.22634ZM10.7335 2.77154C11.0873 2.44644 11.0874 1.9201 10.7335 1.59482L10.2613 1.16207C9.90687 0.83725 9.33223 0.837261 8.97784 1.16209L8.62052 1.48948L10.3764 3.09887L10.7335 2.77154ZM7.91246 2.01119L9.80723 3.74791L3.93182 9.13322L3.93187 9.13326L9.80732 3.74792L7.9125 2.01115L7.91246 2.01119ZM9.66812 3.74791L3.93178 9.00575L2.17622 7.39649L7.91241 2.13865L9.66812 3.74791ZM1.07856 10.0121L3.17243 9.48032L1.65869 8.0927L1.65871 8.09264L3.17253 9.48033L1.07855 10.0121L1.07856 10.0121ZM1.21964 9.88267L1.70836 8.26575L2.98358 9.43472L1.21964 9.88267Z"
                                              fill="#740B99"/>
                                    </svg>
                                </a>
                                <a @click.prevent="confirmDelete(data.item)" href="#" class="decline"
                                   v-if=" data.item.status === 'completed'">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M5.24935 0.583496H8.74935C9.39368 0.583496 9.91602 1.10583 9.91602 1.75016V2.3335H11.666C12.3103 2.3335 12.8327 2.85583 12.8327 3.50016V4.66683C12.8327 5.31116 12.3103 5.8335 11.666 5.8335H11.6192L11.0827 12.25C11.0827 12.8943 10.5603 13.4167 9.916 13.4167H4.08267C3.43833 13.4167 2.916 12.8943 2.91801 12.2984L2.37927 5.8335H2.33268C1.68835 5.8335 1.16602 5.31116 1.16602 4.66683V3.50016C1.16602 2.85583 1.68835 2.3335 2.33268 2.3335H4.08268V1.75016C4.08268 1.10583 4.60502 0.583496 5.24935 0.583496ZM4.08268 3.50016V3.5H2.33266V4.66667H11.666V3.5H9.91602V3.50016H4.08268ZM4.08265 12.2502L3.54977 5.8335H10.4487L9.918 12.2017L9.91599 12.2502H4.08265ZM8.74935 1.75016V2.3335H5.24935V1.75016H8.74935Z"
                                              fill="#740B99"/>
                                    </svg>
                                </a>
                                <a @click.prevent="approveConirmation(data.item)" href="#" class="approve"
                                   v-if="data.item.status === 'pending'">
                                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M15.8488 7.99967C15.8488 6.87802 15.0822 5.99967 13.8143 5.99967H11.7302L11.7491 5.94919C11.7679 5.89908 11.821 5.76146 11.8726 5.62779C11.9183 5.50948 11.9627 5.39427 11.9812 5.34561C12.1101 5.00538 12.2042 4.73125 12.2804 4.45976C12.3954 4.04943 12.4579 3.67975 12.4579 3.33301C12.4579 2.35167 11.842 1.74215 10.9308 1.48133C10.5198 1.36369 10.1621 1.33295 9.74517 1.33301H9.41998L9.21637 1.58226C8.98637 1.86383 8.53461 2.37129 8.01377 2.95634L8.01377 2.95634L8.01375 2.95637C7.05294 4.03564 5.85708 5.37894 5.3847 6.05527C5.26212 6.01948 5.13229 6.00026 4.99789 6.00026H3.64152C2.89242 6.00026 2.28516 6.59722 2.28516 7.3336V13.3336C2.28516 14.07 2.89242 14.6669 3.64152 14.6669H4.99789C5.46388 14.6669 5.87499 14.4359 6.11917 14.0841C6.32491 14.2149 6.55447 14.324 6.80397 14.4118C7.37522 14.6127 7.94178 14.6744 8.41213 14.6659L13.1361 14.6663C15.0046 14.6663 15.8488 11.9621 15.8488 7.99967ZM7.2609 13.1564C6.66077 12.9453 6.35425 12.6012 6.35425 11.9997V7.3336V7.33301C6.35425 7.17288 6.38439 7.03108 6.45036 6.87966C6.56887 6.60767 7.64411 5.40176 8.66325 4.25879L8.66327 4.25876C9.18924 3.66887 9.70027 3.09575 10.0571 2.67643C10.2276 2.689 10.3883 2.71476 10.5516 2.7615C10.9402 2.87274 11.1015 3.03236 11.1015 3.33301C11.1015 3.54406 11.0581 3.80122 10.9728 4.10541C10.909 4.33272 10.8265 4.57325 10.7102 4.88011C10.6937 4.92367 10.6525 5.03037 10.6087 5.14384C10.5553 5.28211 10.4981 5.43042 10.4769 5.4867C10.3887 5.72112 10.3306 5.89372 10.2909 6.05055C10.1219 6.71724 10.2914 7.33301 11.1015 7.33301H13.8143C14.283 7.33301 14.4924 7.57293 14.4924 7.99967C14.4924 11.1935 13.8245 13.333 13.1361 13.333H8.3888L8.36376 13.3334C8.06692 13.3386 7.65001 13.2932 7.2609 13.1564ZM3.64152 13.3336V7.3336H4.99789V13.3336H3.64152Z"
                                              fill="#27AE60"/>
                                    </svg>
                                </a>
                                <a @click.prevent="declineConfirmation(data.item)" href="#" class="decline"
                                   v-if="data.item.status === 'pending'">
                                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M11.3218 10.3714L11.3217 10.3712L11.3216 10.3709C11.2701 10.2374 11.2171 10.1001 11.1983 10.05L11.1794 9.99955H13.2635C14.5314 9.99955 15.298 9.1212 15.298 7.99955C15.298 4.03717 14.4538 1.33288 12.5853 1.33288C12.5853 1.33288 7.85372 1.33303 7.8373 1.33269C7.391 1.32482 6.82444 1.38651 6.25319 1.58742C6.00357 1.67522 5.77392 1.78446 5.56811 1.91534C5.32389 1.5637 4.91292 1.33287 4.44711 1.33287H3.09074C2.34164 1.33287 1.73438 1.92983 1.73438 2.66621V8.66621C1.73438 9.40259 2.34164 9.99954 3.09074 9.99954H4.44711C4.58163 9.99954 4.71158 9.98029 4.83425 9.94444C5.30687 10.6209 6.5024 11.9639 7.46298 13.0429L7.463 13.0429C7.98383 13.6279 8.43559 14.1354 8.66559 14.417L8.8692 14.6662H9.19961C9.61133 14.6663 9.96906 14.6355 10.38 14.5179C11.2912 14.2571 11.9071 13.6476 11.9071 12.6662C11.9071 12.3195 11.8447 11.9498 11.7296 11.5395C11.6535 11.268 11.5594 10.9938 11.4304 10.6536C11.412 10.6051 11.3677 10.4904 11.3222 10.3724L11.3218 10.3714ZM5.80347 8.66621V3.99954C5.80347 3.39806 6.10999 3.0539 6.71012 2.84282C7.09923 2.70597 7.51614 2.66057 7.81469 2.66582L11.591 2.6662L12.5853 2.66621C13.2737 2.66621 13.9417 4.80571 13.9417 7.99954C13.9417 8.42628 13.7323 8.66621 13.2635 8.66621H10.5508C9.74063 8.66621 9.57114 9.28198 9.74009 9.94867C9.77983 10.1055 9.83793 10.2781 9.92612 10.5125C9.94727 10.5687 10.0044 10.7168 10.0577 10.855L10.0579 10.8553L10.0579 10.8555C10.1017 10.9689 10.1429 11.0756 10.1594 11.1191C10.2757 11.426 10.3583 11.6665 10.422 11.8938C10.5073 12.198 10.5508 12.4552 10.5508 12.6662C10.5508 12.9669 10.3895 13.1265 10.0008 13.2377C9.83756 13.2845 9.67684 13.3102 9.50633 13.3228C9.14949 12.9035 8.63847 12.3304 8.1125 11.7405L8.11247 11.7404C7.09333 10.5975 6.01809 9.39155 5.89958 9.11956C5.83361 8.96814 5.80347 8.82634 5.80347 8.66621ZM3.09074 8.66621V2.66621H4.44711V8.66621H3.09074Z"
                                              fill="#EB5757"/>
                                    </svg>
                                </a>
                            </template>
                        </template>
                    </b-table>
                    <b-pagination v-if="pagination.totalPages > 1"
                                  v-model="pagination.currentPage"
                                  :total-rows="pagination.totalRows"
                                  :per-page="pagination.perPage"
                                  align="right"
                                  aria-controls="data-table"
                                  @change="changePage"
                    ></b-pagination>
                </box>
            </div>
        </div>
        <dspConfirmModal
            ref="deleteConfirmModal"
            :message="$t('Do You want to delete transaction?')"
            @cancel="deletingItemId = null"
            @confirm="onDeleteConfirm"
        />
        <dspConfirmModal ref="approveConfirmModal">
            <template slot="modal-header">
                <div class="d-flex justify-content-between align-items-center w-100">
                    <h5>{{ $t('Do You want to approve transaction?') }}</h5>
                    <button type="button" class="close" aria-label="Close" @click="$refs.approveConfirmModal.hide()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </template>
            <div class="text-left">
                <div class="my-1">{{ $t('Id:') }}{{ confirmationTransactionData.id }}</div>
                <div class="my-1">{{ $t('User:') }} {{ confirmationTransactionData.userId }}</div>
                <div class="my-1">{{ $t('Amount:') }} {{ confirmationTransactionData.transactionAmount }}</div>
                <div class="my-1">{{ $t('Type:') }} {{ confirmationTransactionData.type }}</div>
            </div>
            <template slot="modal-footer">
                <dspButton v-on:click="$refs.approveConfirmModal.hide()"
                           class="plain">{{ $t('Cancel') }}
                </dspButton>
                <dspButton v-on:click="$refs.approveConfirmModal.hide(), approve(confirmationTransactionData)"
                           class="primary">{{ $t('Yes') }}
                </dspButton>
            </template>
        </dspConfirmModal>
        <dspConfirmModal ref="declineConfirmModal">
            <template slot="modal-header">
                <div class="d-flex justify-content-between align-items-center w-100">
                    <h5>{{ $t('Do You want to decline transaction?') }}</h5>
                    <button type="button" class="close" aria-label="Close" @click="$refs.declineConfirmModal.hide()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </template>
            <div class="text-left">
                <div class="my-1">{{ $t('Id:') }}{{ confirmationTransactionData.id }}</div>
                <div class="my-1">{{ $t('User:') }} {{ confirmationTransactionData.userId }}</div>
                <div class="my-1">{{ $t('Amount:') }} {{ confirmationTransactionData.transactionAmount }}</div>
                <div class="my-1">{{ $t('Type:') }} {{ confirmationTransactionData.type }}</div>
            </div>
            <template slot="modal-footer">
                <dspButton v-on:click="$refs.declineConfirmModal.hide()"
                           class="plain">{{ $t('Cancel') }}
                </dspButton>
                <dspButton v-on:click="$refs.declineConfirmModal.hide(), decline(confirmationTransactionData)"
                           class="primary">{{ $t('Yes') }}
                </dspButton>
            </template>
        </dspConfirmModal>
    </div>
</template>

<script>
import {debounce} from "debounce";
import sortableColumnHead from "@/components/shared/sortableColumnHead.vue"
import moment from "moment";
import {datesToPeriod} from "@/lib/periodToDates";
import DateSelect from "@/components/DatePicker/DateSelect.vue"

export default {
    components: {
        sortableColumnHead,
        DateSelect,
    },
    name: 'admin-transaction',
    data: function () {
        return {
            fromDate: moment(),
            toDate: moment(),
            rangeName: this.$t('Today'),
            searchText: '',
            sortDesc: true,
            sortBy: 'id',

            searchFieldsList: [
                {
                    value: 'userId',
                    title: this.$t('User ID'),
                },
                {
                    value: 'id',
                    title: this.$t('ID'),
                },
                {
                    value: 'notes',
                    title: this.$t('Description'),
                },

            ],

            searchField: {},

            typesList: [
                {
                    value: null,
                    title: this.$t('All Types'),
                },
                {
                    value: 'depositFunds',
                    title: this.$t('Deposit Funds'),
                },
                {
                    value: 'adCampaignsDailySpend',
                    title: this.$t('Ad Campaigns Daily Spend'),
                },
            ],

            type: {},

            status: {},

            statusList: [
                {
                    value: null,
                    title: this.$t('All'),
                },
                {
                    value: 'pending',
                    title: this.$t('Pending'),
                },
                {
                    value: "completed",
                    title: this.$t('Completed'),
                },
                {
                    value: "canceled",
                    title: this.$t('Canceled'),
                },
            ],


            rolesFilter: [this.$t('All Types')],
            pagination: {
                currentPage: 1,
                perPage: 10,
                totalRows: 100,
                totalPages: 1,
            },
            sortableFields: {
                id: this.$t('ID'),
                createdAt: this.$t('Date'),
                transactionAmount: this.$t('Amount'),
                balanceAfter: this.$t('Sum After'),
                type: this.$t('Type'),
                status: this.$t('Status'),
                method: this.$t('Method'),
            },
            fields: [
                {key: 'id', label: this.$t('ID'), sortable: true, class: 'admin-user-id'},
                {key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'admin-user-name'},
                {key: 'userId', label: this.$t('User ID'), sortable: false, class: 'admin-user-id'},
                // {key:'notes', label: 'Description',  sortable: false, class: 'admin-user-company'},
                {key: 'transactionAmount', label: this.$t("Amount"), sortable: true, class: 'admin-user-role'},
                {key: 'balanceAfter', label: this.$t("Sum After"), sortable: true, class: 'admin-user-manager'},
                {key: 'type', label: this.$t('Type'), sortable: true, class: 'admin-user-manager'},
                {key: 'status', label: this.$t('Status'), sortable: true, class: 'admin-user-manager'},
                {key: 'method', label: this.$t('Method'), sortable: true, class: 'admin-user-manager'},
                {key: 'notes', label: this.$t('Description'), sortable: false, class: 'admin-user-manager pointer-event-none'},
                {key: 'actions', label: this.$t('Actions'), sortable: false, class: 'admin-user-manager pointer-event-none'},
            ],
            confirmationTransactionData: {},

            deletingItemId: null,
        }
    },

    watch: {
        searchText() {
            this.pagination.currentPage = 1;
            this.refreshTableDebounced();
        },

        searchField() {
            if (this.searchText) {
                this.pagination.currentPage = 1;
                this.$refs.transactionsTable.refresh();
            }
        },

        type() {
            this.pagination.currentPage = 1;
            this.$refs.transactionsTable.refresh();
        },

        status() {
            this.pagination.currentPage = 1;
            this.$refs.transactionsTable.refresh();
        },
    },

    created() {
        if (!this.$auth.checkFinanceAdmin()) {
            this.$router.push({name: 'admin.dashboard'});
        }

        this.searchField = this.searchFieldsList.find(() => true);
        this.type = this.typesList.find(i => {
            return i.value === 'depositFunds'
        });
        this.status = this.statusList.find(i => {
            return i.value === null
        });
    },

    methods: {

        sliceText(text) {
            return text.slice(0, 10);
        },
        exportToFile() {
            let sortBy = this.sortBy;
            const params = new URLSearchParams();

            let search = '';
            let searchFields = '';
            if (this.searchText) {
                search = search + ';' + this.searchField.value + ':' + this.searchText;
                searchFields = searchFields + ';' + this.searchField.value + ':like';
            }

            if (this.type.value) {
                search = search + ';type:' + this.type.value;
                searchFields = searchFields + ';type:=';
            }

            if (this.status.value !== null) {
                search = search + ';status:' + this.status.value;
                searchFields = searchFields + ';status:=';
            }

            params.append('search', search);
            params.append('searchJoin', 'and');
            params.append('searchFields', searchFields);
            params.append('orderBy', sortBy);
            params.append('sortedBy', 'desc');
            params.append('with', 'user');
            params.append('from', this.fromDate.format('YYYY-MM-DD'));
            params.append('to', this.toDate.format('YYYY-MM-DD'));

            this.$axios({
                url: '/admin/transactions/download',
                method: 'POST',
                data: params,
                responseType: 'blob', // important
            }, {
                'Accept': 'text/csv'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.csv');
                document.body.appendChild(link);
                link.click();
            })
                .catch(error => {
                    this.$backendErrors(error, this.$t('Error'));
                    return [];
                });
        },
        onPeriodChange(event) {
            this.fromDate = moment(event.dateStart);
            this.toDate = moment(event.dateEnd);
            this.rangeName = datesToPeriod(event.dateStart, event.dateEnd);
            this.$refs.transactionsTable.refresh();
        },

        changePage(pageNo) {
            this.pagination.currentPage = pageNo;
            this.$refs.transactionsTable.refresh();
        },

        refreshTableDebounced: debounce(function () {
            this.$refs.transactionsTable.refresh();
        }, 1000),

        transactionsProvider(ctx) {
            let sortBy = ctx.sortBy;
            const params = new URLSearchParams();
            params.append('page', this.pagination.currentPage);

            let search = '';
            let searchFields = '';
            if (this.searchText) {
                search = search + ';' + this.searchField.value + ':' + this.searchText;
                searchFields = searchFields + ';' + this.searchField.value + ':like';
            }

            if (this.type.value) {
                search = search + ';type:' + this.type.value;
                searchFields = searchFields + ';type:=';
            }

            if (this.status.value !== null) {
                search = search + ';status:' + this.status.value;
                searchFields = searchFields + ';status:=';
            }

            params.append('search', search);
            params.append('searchJoin', 'and');
            params.append('searchFields', searchFields);
            params.append('orderBy', sortBy);
            params.append('sortedBy', ctx.sortDesc ? 'desc' : 'asc');
            params.append('with', 'user');
            params.append('from', this.fromDate.format('YYYY-MM-DD'));
            params.append('to', this.toDate.format('YYYY-MM-DD'));

            return this.axios.get('/admin/transactions', {params: params})
                .then(response => {
                    this.pagination.currentPage = response.data.meta.pagination.current_page;
                    this.pagination.perPage = response.data.meta.pagination.per_page;
                    this.pagination.totalRows = response.data.meta.pagination.total;
                    this.pagination.totalPages = response.data.meta.pagination.total_pages;

                    return response.data.data.map(item => ({
                        id: item.id,
                        createdAt: item.createdAt.slice(0, 16),
                        userId: item.userId,
                        notes: item.notes,
                        transactionAmount: item.transactionAmount,
                        balanceAfter: item.balanceAfter,
                        userBalance: item.user ? item.user.balance : 0,
                        type: item.type,
                        status: item.status,
                        method: item.methodString
                    }))
                })
                .catch(error => {
                    this.pagination.currentPage = 0;
                    this.pagination.perPage = 0;
                    this.pagination.totalRows = 0;
                    this.items = [];

                    this.$backendErrors(error, this.$t('Error'));

                    return [];
                });
        },
        approveConirmation(item) {
            this.confirmationTransactionData = item;
            this.$refs.approveConfirmModal.show()
        },
        approve(item) {
            this.$axios.put('/admin/transactions/approve', {status: 'completed', id: item.id}).then(
                resp => {
                    item.status = resp.data.data.status;
                    item.transactionAmount = resp.data.data.transactionAmount;
                    item.transactionAmount = resp.data.data.transactionAmount;
                    item.balanceAfter = resp.data.data.balanceAfter;
                    this.$notify.info(resp.data.message);
                }
            ).catch(
                () => {
                    this.$notify.info(this.$t('Error approving transaction'));
                }
            );
        },
        declineConfirmation(item) {
            this.confirmationTransactionData = item;
            this.$refs.declineConfirmModal.show()
        },
        decline(item) {
            this.$axios.put('/admin/transactions/decline', {status: 'canceled', id: item.id}).then(
                resp => {
                    item.status = resp.data.data.status;
                    item.transactionAmount = resp.data.data.transactionAmount;
                    item.transactionAmount = resp.data.data.transactionAmount;
                    item.balanceAfter = resp.data.data.balanceAfter;
                    this.$notify.info(resp.data.message);
                }
            ).catch(
                () => {
                    this.$notify.info(this.$t('Error approving transaction'));
                }
            );
        },
        edit(item) {
            this.$router.push({name: 'admin.transactions.edit', params: {id: item.id}})
        },
        confirmDelete(item) {
            this.deletingItemId = item.id;
            this.$refs.deleteConfirmModal.show();
        },
        onDeleteConfirm() {
            this.$refs.deleteConfirmModal.hide();
            this.$axios.delete(`/admin/transactions/${this.deletingItemId}`).then(res => {
                this.$refs.transactionsTable.refresh();
                this.$notify.info(res.data.data.message);
            });
        },
        updateTransaction(transaction, value, field) {

            let data = {};
            data[field] = value;

            this.$validator.errors.clear();
            this.saveBtnDiasbled = true;
            this.$axios.patch('/admin/transactions/' + transaction.id, data).then(
                resp => {
                    transaction[field] = value;
                    this.$notify.info(resp.data.message);

                }
            ).catch(error => {
                this.$backendErrors(error, this.$t('Error save transaction: '), this.$validator);
            })
        }

    }

}
</script>
